export default __webpack_public_path__ + "static/media/BrainBreak cards56.73d7278d.png";